// removed by extract-text-webpack-plugin
module.exports = {"screen":"screen--RtemO screen--27rYG"};


//////////////////
// WEBPACK FOOTER
// ./src/EightBitScreen/EightBitScreen.css
// module id = 6uOm
// module chunks = 1